import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { bootstrapOAuthBrowserSession } from '@/features/auth/oauth/api'
import {
  consumeOAuthAuthorizationReturnUrl,
  normalizeOAuthAuthorizationReturnUrl,
  persistOAuthAuthorizationReturnUrl,
} from '@/features/auth/oauth/authorization-resume'
import { normalizeLanguage } from '@/i18n/i18n'
import { hasPortalSession } from '@/lib/auth/portal-routes'

function requestedAuthorizationUrl() {
  return normalizeOAuthAuthorizationReturnUrl(
    new URLSearchParams(window.location.search).get('authorization'),
  )
}

export function useOAuthAuthorizationResumePage() {
  const { i18n, t } = useTranslation('auth')
  const language = normalizeLanguage(i18n.language)
  const attemptedRef = useRef(false)
  const authorizationUrl = requestedAuthorizationUrl()
  const [failed, setFailed] = useState(!authorizationUrl)

  useEffect(() => {
    if (attemptedRef.current) return
    attemptedRef.current = true
    if (!authorizationUrl) return
    persistOAuthAuthorizationReturnUrl(authorizationUrl)
    if (!hasPortalSession('user')) {
      window.location.replace('/login?resume=oauth_authorization')
      return
    }
    void bootstrapOAuthBrowserSession()
      .then(() => {
        const target = consumeOAuthAuthorizationReturnUrl()
        if (target) window.location.replace(target)
      })
      .catch(() => setFailed(true))
  }, [authorizationUrl])

  return { failed, language, t }
}
